import apiFetch from '../apiFetch'

export default function (token, dossierId) {
  return apiFetch({ endPoint: `audit/info?dossierId=${dossierId}`, method: 'GET', body: null, token: token })
}
